import script from "./DashboardHeroPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHeroPanel.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHeroPanel.vue?vue&type=style&index=0&id=18a9dadc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a9dadc"]])

export default __exports__